import React, {Component, PropTypes} from 'react';
import {
  Button,
  Modal,
} from '@sketchpixy/rubix';
import styled from 'styled-components';
import {ClipLoader} from 'react-spinners';
import {css} from 'react-emotion';

import {activateContract} from '../../../api/api';

const override = css`
  margin: auto 8px auto auto;
`;

const ButtonText = styled.div`
  display: flex;
`;

class ActivateContractModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  activateContract = () => {
    this.setState({
      loading: true,
    });

    activateContract(this.props.contractId, (err, result) => {
      this.setState({
        loading: false,
      });

      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        if (result.statusCode === "0" || result.statusCode === 0) {
          this.props.closeModal(result.contract);
        } else {
          this.props.closeModal();
          Messenger().post({
            type: 'error',
            message: `Failed Activate the contract`,
            showCloseButton: true,
          });
        }
      }
    });
  };

  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Activate Contract</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Would you like to activate the contract?
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.props.closeModal}>Cancel</Button>
            <Button bsStyle="brownishgray" onClick={this.activateContract} disabled={this.state.loading}>
              <ButtonText>
                <ClipLoader
                    className={override}
                    sizeUnit={'px'}
                    size={12}
                    color={'#123abc'}
                    loading={this.state.loading}
                />
                <span>
                  Confirm
                </span>
              </ButtonText>
            </Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

ActivateContractModal.propTypes = {
  contractId: PropTypes.number.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ActivateContractModal;



// WEBPACK FOOTER //
// ./src/routes/patient/Modal/ActivateContractModal.js